import type { SteelOrderMatchingStatusEnum, SteelOrderQualityCheckStatusEnum } from '@mbfab/client-api'

import type { StatusTone } from '@/components/ui/status-dot'
import { StatusDot } from '@/components/ui/status-dot'

export type { StatusTone } from '@/components/ui/status-dot'
export { StatusDot } from '@/components/ui/status-dot'

// ミルシートステータス・発注ステータス共通の表示（v1 MatchingStatusLabel と同じ enum・ラベル対応）
export function MatchingStatusLabel({ status }: { status: SteelOrderMatchingStatusEnum }) {
  switch (status) {
    case 'completed':
      return <StatusDot tone="ok" label="完了" />
    case 'incomplete':
      return <StatusDot tone="progress" label="未完了" />
    case 'unregistered':
      // 「未登録」は取込直後の既定状態で異常ではないため、警告色に見せない（v1 と同じ）
      return <StatusDot tone="idle" label="未登録" />
  }
}

// ミルシートステータスは「対象外」フラグを優先する（v1 steelOrderLabels.tsx の MillsheetStatusLabel と同じ）。
// 不足量（あと何kg）の併記は呼び出し側（orders-table-columns.tsx）で行う。testid を
// ステータス本体と不足量とで分ける必要があり（v1 と同じ理由）、ここに含めると分離できないため
export function MillsheetStatusLabel({
  millsheetStatus,
  isMillsheetExcluded,
}: {
  millsheetStatus: SteelOrderMatchingStatusEnum
  isMillsheetExcluded: boolean
}) {
  if (isMillsheetExcluded) {
    return <StatusDot tone="off" label="対象外" />
  }
  return <MatchingStatusLabel status={millsheetStatus} />
}

// ミルシートステータス・発注ステータスと同じトーン対応（completed=ok / incomplete=progress / unregistered=idle）
export function QualityCheckStatusLabel({ status }: { status: SteelOrderQualityCheckStatusEnum }) {
  switch (status) {
    case 'completed':
      return <StatusDot tone="ok" label="完了" />
    case 'incomplete':
      return <StatusDot tone="progress" label="未完了" />
    case 'unregistered':
      return <StatusDot tone="idle" label="未登録" />
  }
}

// 汎用の文字列ベースのステータス表示。ラベル文字列から StatusDot のトーンを引く
const genericStatusTone: Record<string, StatusTone> = {
  完了: 'ok',
  照合済: 'ok',
  登録済: 'ok',
  成功: 'ok',
  処理中: 'progress',
  確認中: 'progress',
  一部成功: 'progress',
  未処理: 'idle',
  未登録: 'idle',
  差異あり: 'progress',
  失敗: 'ng',
}

export function StatusIndicator({ value }: { value: string }) {
  return <StatusDot tone={genericStatusTone[value] ?? 'idle'} label={value} />
}
